module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1292.9536f383.png";